import React from "react";

const ExclamationMarkTriangle: React.FC<React.SVGProps<SVGSVGElement>> = ({ width = 16, height = 16, ...props }) => {
	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			role="img"
			aria-label="Exclamation mark triangle icon"
			{...props}
		>
			<path
				d="M8 1.5L1.5 13.5H14.5L8 1.5Z"
				fill="currentColor"
			/>
			<path
				d="M8 6V9"
				stroke="var(--triangle-cutout-color, white)"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
			<circle cx="8" cy="11.5" r="0.75" fill="var(--triangle-cutout-color, white)" />
		</svg>
	);
};

export default ExclamationMarkTriangle;